export interface ShowOnlyInvalidQuestionsActionType {
  type: '@formCreator/SHOW_ONLY_INVALID_QUESTIONS';
}

export type ShowOnlyInvalidQuestionsFunctionType = () => void;

export const showOnlyInvalidQuestions = (): ShowOnlyInvalidQuestionsActionType => ({
  type: '@formCreator/SHOW_ONLY_INVALID_QUESTIONS',
});
